import { render, staticRenderFns } from "./CategoriaModal.vue?vue&type=template&id=7fbc3cbe&scoped=true"
import script from "./CategoriaModal.vue?vue&type=script&lang=js"
export * from "./CategoriaModal.vue?vue&type=script&lang=js"
import style0 from "./CategoriaModal.vue?vue&type=style&index=0&id=7fbc3cbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbc3cbe",
  null
  
)

export default component.exports